import { render, staticRenderFns } from "./LanguageToggle.vue?vue&type=template&id=0fb71d06&scoped=true"
import script from "./LanguageToggle.vue?vue&type=script&lang=ts"
export * from "./LanguageToggle.vue?vue&type=script&lang=ts"
import style0 from "./LanguageToggle.vue?vue&type=style&index=0&id=0fb71d06&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@corefy+vue2-vue-template-compiler@2.7.24_css-loader@6.8.1_webpack@5_7038a5b31aeda1c26d50c85a281906e5/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb71d06",
  null
  
)

export default component.exports